module.exports = __webpack_public_path__ + "static/media/user.8ab4fb8c.svg";